/**
 * Maps backend session datapoint variable names to keys used under
 * `feedbackTexts.player.strengths.*` / `player.weaknesses.*` where they diverge.
 *
 * Source of truth for eligible metrics: `normalizedPlayerProfileDatapointDirections`
 * in transition-firebase/functions/src/voice-processing/normalizationHelper.ts
 */
export const STRENGTH_VARIABLE_LOCALE_ALIASES: Readonly<Record<string, string>> = {
  playerInformReport: 'informReport',
  playerReceipt: 'receipt',
  playerAgreeSupport: 'agreeSupport',
  playerDisagreeChallengeIssue: 'disagreeChallengeIssue',
  playerDelegateAssign: 'delegateAssign',
  playerOfferHelp: 'offerHelp',
  playerInvite: 'invite',
  playerRoleTalk: 'roleTalk',
  playerAdmitMistake: 'admitMistake',
  playerThank: 'thank',
  playerConstructiveFeedback: 'constructiveFeedback',
  playerGoalOrientation: 'goalOrientation',
  playerAirtimePreplanning: 'playerAirtimePrePlanning',
  playerAirtimeRelativePreplanning: 'playerAirtimeRelativePrePlanning',
  /** BE uses lowercase `planning`; canonical locale keys use `Planning` */
  playerTimesTalkedPreplanning: 'playerTimesTalkedPrePlanning',
  /** BE camelCase vs locale key capitalization */
  playerOverlapAirtimeTimesPreplanning: 'playerOverlapAirtimeTimesPrePlanning',
  /** Metrics present in strengths ranking but keyed without `player` prefix in feedbackTexts */
  playerPlanNextStep: 'planNextStep',
  playerAskForHelp: 'askForHelp',
  /** If these appear in profile strengths in future BE versions */
  playerInactiveTimeOutside: 'inactiveTimeOutside',
  playerInactiveTimeInside: 'inactiveTimeInside',
  playerAskQuestionOpen: 'askQuestionOpen',
  playerAskQuestionClarifyConfirm: 'askQuestionClarifyConfirm'
}

export function resolveStrengthVariableForLocales(variable: string): string {
  return STRENGTH_VARIABLE_LOCALE_ALIASES[variable] ?? variable
}

/**
 * Weaknesses keep the `player` prefix (unlike strengths), so only the casing divergences apply:
 * BE sends lowercase `…Preplanning`, the locale keys under `player.weaknesses.*` use `…PrePlanning`.
 */
export const WEAKNESS_VARIABLE_LOCALE_ALIASES: Readonly<Record<string, string>> = {
  playerAirtimePreplanning: 'playerAirtimePrePlanning',
  playerAirtimeRelativePreplanning: 'playerAirtimeRelativePrePlanning',
  playerOverlapAirtimeTimesPreplanning: 'playerOverlapAirtimeTimesPrePlanning',
  playerTimesTalkedPreplanning: 'playerTimesTalkedPrePlanning'
}

export function resolveWeaknessVariableForLocales(variable: string): string {
  return WEAKNESS_VARIABLE_LOCALE_ALIASES[variable] ?? variable
}
